import React, { useState } from 'react';

// Digits and one point, four decimals: a rate is quoted finer than an amount.
const cleanRate = (raw) => {
  const [whole = '', ...rest] = String(raw).replace(/[^\d.]/g, '').split('.');
  return rest.length ? `${whole.slice(0, 4)}.${rest.join('').slice(0, 4)}` : whole.slice(0, 4);
};

// Who published the rate. The label is only ever the name of the figure's real
// source: for a currency other than the dollar, the BRH's dollar crossed with
// the market's rate against it, and both are named.
const ORIGINS = { brh: 'BRH', 'er-api': 'open.er-api.com', 'brh+er-api': 'BRH · er-api' };

/** "1 USD = [130.53] HTG · Source: BRH" — the rate, editable, and where it came from. */
export default function RateBar({ exchange, foreign = 'usd', t }) {
  const { rate, source, origin, setManualRate, clearManualRate } = exchange;
  const [draft, setDraft] = useState(null);   // what is being typed, while the field has focus

  const onChange = (e) => {
    const text = cleanRate(e.target.value);
    setDraft(text);
    setManualRate(parseFloat(text));
  };

  return (
    <div className="rate" data-source={source}>
      <label className="rate-field">
        <span>1 {foreign.toUpperCase()} =</span>
        <input
          className="rate-input"
          inputMode="decimal"
          autoComplete="off"
          aria-label={t('rate.aria', { currency: t(`cur.${foreign}`).toLowerCase() })}
          placeholder="0.00"
          value={draft ?? (rate ? rate.toFixed(2) : '')}
          onChange={onChange}
          onFocus={(e) => e.target.select()}
          onBlur={() => setDraft(null)}
        />
        <span>HTG</span>
      </label>
      <span className="rate-source">
        <i className="rate-dot" />
        {origin ? t('rate.source', { name: ORIGINS[origin] }) : t(`rate.${source}`)}
      </span>
      {source === 'manual' && (
        <button className="rate-reset" type="button" onClick={clearManualRate}
          aria-label={t('rate.reset')} title={t('rate.reset')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M3 12a9 9 0 1 0 3-6.7" />
            <path d="M3 4v5h5" />
          </svg>
        </button>
      )}
    </div>
  );
}
